

import axios from 'axios';
const headersmultipart={'Accept':'application/json',"Content-Type": "multipart/form-data"};




export const  axios_files_getclientdocs = async (id_lead,courtier)=>{
    return  await axios.post(`/files/getclientdocs/`,{id_lead,courtier},{headers:{'Accept':'application/json',"Content-Type":"application/json"}});
}

export const  axios_files_registerdocument = async (jsondocuments)=>{
    return  await axios.post(`/files/registerdocument`,{...jsondocuments},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}}) ;
}

export const  axios_files_listdocsclientS3 = async (directory)=>{
    return  await axios.post(`/files/listdocsclientS3`,{'directory':directory});
}

export const  axios_files_addclientfile = async (data,onuploadprogress)=>{
    return  await axios.post(`/files/addclientfile/`,data,{headers:headersmultipart,onUploadProgress:(p)=>{onuploadprogress(p)}});
}

export const  axios_files_deleteclientfile = async (url)=>{
    return  await axios({method:'POST',url:`/files/deleteclientfile`,data: {'url':url}}) ;
}


export const  axios_files_addfilecompagnie = async (data)=>{
    return  await axios.post(`/files/addfilecompagnie/`, data ,{headers:headersmultipart});
}


export const  axios_files_deletefilecompagnie = async (typefile,nomfile)=>{
    return  await axios.post(`/files/deletefilecompagnie/`,{typefile,nomfile},{headers:{'Accept':'application/json',"Content-Type":"application/json"}});
}
